import { Medium, Bold, UhcSans } from '@src/apps/styles/common-style';
import styled from 'styled-components';

export const AdvanceSearchStyle = {
  'abyss-search-input-root': {
    width: '100%',
    minWidth: '260px',
    maxWidth: '440px',
  },
  // search input clear or close icon
  'abyss-search-input-clear': {
    '.material-symbols-rounded-filled': {
      fontSize: '18px !important',
    },
  },
  // search input search icon
  'abyss-search-input-icon-container': {
    '.material-symbols-rounded-filled': {
      fontSize: '18px !important',
    },
  },
  // search input box
  'abyss-search-input-input': {
    color: '#4B4D4F',
    overflow: 'hidden',
    padding: '0 36px 0 8px',
    fontFamily: `${UhcSans}`,
    fontWeight: 500,
    borderRadius: '5px',
    border: '1px solid #4B4D4F',
    fontSize: '14px !important',
    background: '#fff',
    letterSpacing: '0.2px',
    '&::placeholder': {
      fontFamily: `${UhcSans}`,
      color: '#69696a !important',
      textOverflow: 'ellipsis',
      fontSize: '14px !important',
      fontStyle: 'normal',
      fontWeight: 300,
      lineHeight: 'normal',
    },
    '&:active': {
      borderColor: '#196ECF !important',
    },
    '&:focus': {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: '#196ECF !important',
      outline: 'none !important',
      boxShadow: 'none',
    },
  },
  // for disabling search option icon
  'abyss-search-input-option-icon': { display: 'none !important' },
  'abyss-search-input-option-list': {
    boxSizing: 'border-box',
    borderColor: '#196ECF !important',
    padding: '0px !important',
    marginTop: '0px !important',
    borderRadius: '5px',
    maxHeight: '210px !important',
    overflowY: 'auto !important',
    '&::-webkit-scrollbar': {
      width: '20px',
      padding: '0 5px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent !important',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
      borderRadius: '10px',
      height: '17px',
      boxShadow: 'inset 0 0 0 5px #ffffff',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#a8a8a8',
    },
  },
  'abyss-search-input-option': {
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: '#f0f0f0 !important',
    },
    '&:active': {
      backgroundColor: '#f0f0f0 !important',
    },
    '&:focus': {
      backgroundColor: '#f0f0f0 !important',
    },
    '&:focus-visible': {
      backgroundColor: '#f0f0f0 !important',
    },
    '&:focus-within': {
      backgroundColor: '#f0f0f0 !important',
    },
  },
  'abyss-search-input-option-content': {
    fontFamily: `${Bold}`,
    fontSize: '14px !important',
  },
  'abyss-search-input-no-options': {
    color: '#4B4D4F',
    fontSize: '14px !important',
    textAlign: 'left',
    fontFamily: `${UhcSans}`,
    fontWeight: 500,
    lineHeight: '16px',
    leadingTrim: 'both',
    textEdge: 'cap',
    letterSpacing: '0.2px',
  },
  'abyss-search-input-loading-container': {
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    '.abyss-loading-spinner-root': { height: '30px' },
    '.abyss-c-cMnuow': { stroke: '#448aff' },
  },
  'abyss-search-input-loading-spinner': {
    height: '30px',
    stroke: '#448aff',
  },
};

export const toggleSwitchCss = {
  'abyss-toggle-switch-root': { marginTop: '0px !important', height: '38px' },
  'abyss-toggle-switch-container': {
    boxSizing: 'border-box',
  },
  'abyss-toggle-switch': {
    margin: '0px !important',
    '&:focus': {
      outline: 'none !important',
      boxShadow: 'none',
    },
  },
  'abyss-layout-group': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  'abyss-toggle-switch-label': {
    paddingTop: '5px',
    fontFamily: `${Medium}`,
  },
};

export const ContainerStyle = styled.div`
  display: inline-flex;
  height: 40px;
  gap: 15px;
  width: 100%;
`;

export const OptionContainer = styled.div`
  display: flex;
  padding: 3px 0;
  align-items: center;
  align-self: stretch;
`;

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const OptionLabel = styled.span`
  font-weight: 400;
  text-align: left;
  font-family: ${Bold};
  font-size: 14px;
  line-height: 14px;
  font-style: normal;
  letter-spacing: 0.02em;
`;

export const OptionSubtitle = styled.span`
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: #757588;
  font-family: ${Medium};
  font-style: normal;
  line-height: 1;
`;
